import React, { useState } from "react";
import {
  Drawer,
  Button,
  Popconfirm,
  Typography,
  Popover,
  Space,
  Modal,
  notification,
} from "antd";
import { MyStyledTable } from "../../style/styleComp";
import Card from "antd/es/card/Card";
import moment from "moment";
import {
  PlusOutlined,
  DeleteOutlined,
  InfoCircleOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";

const HoDetailDrawer = ({
  visible,
  onClose,
  data ,
  onStatusChange,
  // statusDetails,
  // countDetails,
}) => {
console.log("Received data in HoDetailDrawer:", data);
  if (!data) {
    return null;
  }

  const { Text, Title } = Typography;

  const [openDialog, setOpenDialog] = useState(false);
  const [istempMark, setIsTempMark] = useState(false);
  const [loading, setLoading] = useState(false);

  if (!data || typeof data !== "object" || !data.tracking_number) {
    // console.error("Invalid data format:", data);
    return <div></div>;
  }

  const getStatusText = (statusCode) => {
    switch (statusCode) {
      case "1":
        return "In-Transit";
      case "2":
        return "In-Query";
      case "3":
        return "Received";
      default:
        return "";
    }
  };


const handleFinalMarkReceived = () => {
  setLoading(true);

  if (onStatusChange) {
    const callbackData = {
      tracking_number: data.tracking_number,
      app_id: data.application_ids,
      status: "Received",
    };
    console.log("Callback data for status change:", callbackData);

    onStatusChange(callbackData)
      .then((response) => {
        setLoading(false);
       
      })
      .catch((error) => {
        setLoading(false);
      
      });
  }
};

  const tableData = data.application_ids.map((appId) => {
    const applicant = data.applicant_details[appId];
    return {
      key: appId,
      tracking_number: data.tracking_number,
      status: getStatusText(data?.status),
      branch: data.branch,
      created_at: moment
        .utc(data.created_at)
        .utcOffset(5.5)
        .format("DD-MM-YYYY"),
      applicant_name: applicant ? applicant.applicant_name : "",
      partner_loan_id: applicant ? applicant.partner_loan_id : "",
      application_id: appId,
    };
  });

  // console.log("tableData", tableData);

  const columns = [
    // {
    //   title: "POD Number",
    //   dataIndex: "tracking_number",
    //   key: "tracking_number",
    // },
    {
      title: "Application ID",
      dataIndex: "application_id",
      key: "application_id",
    },

    {
      title: "Partner Loan ID",
      dataIndex: "partner_loan_id",
      key: "partner_loan_id",
    },
    {
      title: "Applicant Name",
      dataIndex: "applicant_name",
      key: "applicant_name",
    },

    // { title: "Status", dataIndex: "status", key: "status" },

    { title: "Branch", dataIndex: "branch", key: "branch" },

    { title: "Sent on", dataIndex: "created_at", key: "created_at" },
  ];

  const handleDrawerClose = () => {
    if (istempMark) {
      setOpenDialog(true);
      // console.log("open dialog", openDialog);
    } else {
      onClose();
    }
  };

  const handleSaveAndClose = () => {
    // console.log("openDialog",openDialog)
    setOpenDialog(false);
    handleFinalMarkReceived();
    // onClose();
  };

  const handleTempMarkReceived = () => {
    setIsTempMark(!istempMark);
  };

  const handleCancelAndClose = () => {
    setOpenDialog(false);
    onClose();
    setIsTempMark(false);
  };

  const isDataAvailable = tableData.length > 0;

  return (
    // new design
    <Drawer
      title={
        <div style={{ display: "flex", alignItems: "center" }}>
          <Popover
            content={`This courier has ${tableData?.length} number of Application ID (s) which are In-Transit now`}
            title="In-Transit"
            trigger="hover"
          >
            <InfoCircleOutlined
              style={{
                marginRight: "8px",
                color: "#1890ff",
                fontSize: "28px",
              }}
            />
          </Popover>

          <Title
            level={4}
            style={{
              marginBottom: "30px",
              color: "rgba(0, 0, 0, 0.7)",
              fontSize: "20px",
              fontFamily: "Poppins",
              marginLeft: "5px",
            }}
          >
            Courier details
          </Title>
        </div>
      }
      visible={visible}
      onClose={handleDrawerClose}
      width={850}
    >
      <div style={{ padding: "0 20px" }}>
        <Space
          style={{
            display: "flex",
            marginBottom: "30px",
            padding: "0 8px",
            borderRadius: "4px",
            backgroundColor: "#ffffff",
            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            fontSize: "20px",
            fontFamily: "Poppins",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <strong style={{ color: "#555" }}>Status :</strong>
          {istempMark ? (
            <Text
              style={{
                fontSize: "18px",
                fontFamily: "Poppins",
                display: "flex",
                justifyContent: "space-between",
                backgroundColor: "green",
                padding: "3px 8px",
                color: "white",
                borderRadius: "6px",
              }}
            >
              Received
            </Text>
          ) : (
            <Text
              style={{
                fontSize: "18px",
                fontFamily: "Poppins",
                display: "flex",
                justifyContent: "space-between",
                backgroundColor: "orange",
                padding: "3px 8px",
                color: "white",
                borderRadius: "6px",
              }}
            >
              {tableData[0]?.status}
            </Text>
          )}
        </Space>

        <Space
          style={{
            display: "flex",
            marginBottom: "30px",
            padding: "8px",
            borderRadius: "4px",
            backgroundColor: "#ffffff",
            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            fontSize: "20px",
            fontFamily: "Poppins",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <strong style={{ color: "#555" }}>POD Number :</strong>
          <Text
            style={{
              fontSize: "18px",
              fontFamily: "Poppins",
              display: "flex",
              justifyContent: "space-between",
              fontWeight: "800",
            }}
          >
            {tableData[0]?.tracking_number}
          </Text>
        </Space>

        <Space
          style={{
            display: "flex",
            marginBottom: "30px",
            padding: "8px",
            borderRadius: "4px",
            backgroundColor: "#ffffff",
            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            fontSize: "20px",
            fontFamily: "Poppins",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <strong style={{ color: "#555" }}>Branch :</strong>
          <Text
            style={{
              fontSize: "18px",
              fontFamily: "Poppins",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            {tableData[0]?.branch}
          </Text>
        </Space>

        <Space
          style={{
            display: "flex",
            marginBottom: "30px",
            padding: "8px",
            borderRadius: "4px",
            backgroundColor: "#ffffff",
            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            fontSize: "20px",
            fontFamily: "Poppins",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <strong style={{ color: "#555" }}>Vendor :</strong>
          <Text
            style={{
              fontSize: "18px",
              fontFamily: "Poppins",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            {data.vendor}
          </Text>
        </Space>

        <Space
          style={{
            display: "flex",
            marginBottom: "30px",
            padding: "8px",
            borderRadius: "4px",
            backgroundColor: "#ffffff",
            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            fontSize: "20px",
            fontFamily: "Poppins",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <strong style={{ color: "#555" }}>dispatched by :</strong>
          <Text
            style={{
              fontSize: "18px",
              fontFamily: "Poppins",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            {data?.courier_dispatcher_name}
          </Text>
        </Space>

        <Space
          style={{
            display: "flex",
            marginBottom: "30px",
            padding: "8px",
            borderRadius: "4px",
            // backgroundColor: "#ffffff",
            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            fontSize: "20px",
            fontFamily: "Poppins",
            display: "flex",
            justifyContent: "space-between",
            color: "white",
          }}
        >
          <strong style={{ color: "#555" }}>Recieved :</strong>

          {/* rendering received btn according to temp mark  */}

          {istempMark ? (
            <Button
              type="danger"
              onClick={handleTempMarkReceived}
              disabled={
                isDataAvailable &&
                (data.status === "Received" || data.status === "3")
              }
              style={{
                textAlign: "start",
                marginLeft: "25px",
                backgroundColor: "orange",
                color: "white",
                fontFamily: "Poppins",
                fontSize: "18px",
              }}
            >
              {isDataAvailable && data.status === "Received"
                ? "All Items Received"
                : "Click Here To Mark As In-Transit"}
            </Button>
          ) : (
            <Button
              type="primary"
              onClick={handleTempMarkReceived}
              disabled={
                isDataAvailable &&
                (data.status === "Received" || data.status === "3")
              }
              style={{
                textAlign: "start",
                marginLeft: "25px",
                backgroundColor: "red",
                color: "white",
                fontFamily: "Poppins",
                fontSize: "18px",
              }}
            >
              {isDataAvailable && data.status === "Received"
                ? "All Items Received"
                : "Click Here To Mark Courier As Received"}
            </Button>
          )}
        </Space>

        {/* <DotLottieReact
        // style={{height:"140px"}}
        style={{height:"340px"}}
          src="https://lottie.host/192b7b87-551c-4613-963a-38a4f5e287b0/Cb0ycCrqFf.lottie"
          loop
          autoplay
        /> */}
        {istempMark && (
        <Button
        type="primary"
        onClick={handleFinalMarkReceived}
        loading={loading}
         style={{
               marginTop:"30px",
                fontFamily: "Poppins",
                fontSize: "14px",
                width:"100%"
              }}
      >
        Mark Courier As Received
      </Button>
      
        )}
      </div>

      {/* Confirmation Dialog */}
      <Modal
        visible={openDialog}
        title="Courier received"
        onOk={handleSaveAndClose}
        onCancel={handleCancelAndClose}
        cancelText="Don't Save"
        okText="Save Changes"
        centered
      >
        <Text>Do you want to save ?</Text>
      </Modal>
    </Drawer>
  );
};

export default HoDetailDrawer;
